const LOAD_DETAIL_INSTITUTIONS           = 'LOAD_DETAIL_INSTITUTIONS'
const LOAD_DETAIL_INSTITUTIONS_SUCCESS   = 'LOAD_DETAIL_INSTITUTIONS_SUCCESS'
const LOAD_DETAIL_INSTITUTIONS_FAILED    = 'LOAD_DETAIL_INSTITUTIONS_FAILED'
const UNMOUNT_DETAIL_INSTITUTIONS        = 'UNMOUNT_DETAIL_INSTITUTIONS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const institutionsDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_INSTITUTIONS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_INSTITUTIONS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_INSTITUTIONS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_INSTITUTIONS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default institutionsDetailReducer;